__turbopack_context__.v({
  "fade-in": "BackgroundGradient-module-scss-module__qGP7pW__fade-in",
  "float": "BackgroundGradient-module-scss-module__qGP7pW__float",
  "gradient": "BackgroundGradient-module-scss-module__qGP7pW__gradient",
  "no-transform": "BackgroundGradient-module-scss-module__qGP7pW__no-transform",
  "path-1": "BackgroundGradient-module-scss-module__qGP7pW__path-1",
  "path-2": "BackgroundGradient-module-scss-module__qGP7pW__path-2",
  "path-3": "BackgroundGradient-module-scss-module__qGP7pW__path-3",
  "rotate": "BackgroundGradient-module-scss-module__qGP7pW__rotate",
  "soft-blobs": "BackgroundGradient-module-scss-module__qGP7pW__soft-blobs",
  "wrapper": "BackgroundGradient-module-scss-module__qGP7pW__wrapper",
});
